export const comments_5480351 = {"data":{"data":[],"links":{}}}